import { useMutation, useQuery } from "@tanstack/react-query";
import benchmarksService from "src/queries/services/benchmarks";
import { FETCH_QUERY_KEYS } from "../consts";

export const useFetchBenchmarksSetup = (assistantId, { enabled = true } = {}) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.BENCHMARKS_SETUP, assistantId],
  queryFn: ({ signal }) => benchmarksService.fetchBenchmarksSetup(assistantId, { signal }),
  enabled: !!assistantId && enabled
});

// The channel belongs in the query key: benchmarks are keyed on it server-side, so
// without it two agents on different channels would serve each other's cached values.
export const useFetchBenchmarkDefaults = (channel, { enabled = true } = {}) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.BENCHMARK_DEFAULTS, channel],
  queryFn: () => benchmarksService.fetchBenchmarkDefaults(channel),
  enabled
});

export const useFetchBenchmarkOverrides = (assistantId, benchmarksSetup, channel, { enabled = true } = {}) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.BENCHMARK_OVERRIDES, assistantId, benchmarksSetup, channel],
  queryFn: () => benchmarksService.fetchBenchmarkOverrides(assistantId, benchmarksSetup, channel),
  enabled: !!assistantId && !!benchmarksSetup && enabled
});

export const useFetchAllSetups = () => useQuery({
  queryKey: [FETCH_QUERY_KEYS.ALL_SETUPS],
  queryFn: () => benchmarksService.fetchAllSetups()
});

export const useUpsertBenchmarksSetup = (options = {}) => useMutation({
  mutationFn: ({ assistantId, data }) => benchmarksService.upsertBenchmarksSetup(assistantId, data),
  ...options
});

export const useCreateBenchmarkOverride = (options = {}) => useMutation({
  mutationFn: (data) => benchmarksService.createBenchmarkOverride(data),
  ...options
});

export const useUpdateBenchmarkOverride = (options = {}) => useMutation({
  mutationFn: (data) => benchmarksService.updateBenchmarkOverride(data),
  ...options
});

export const useDeleteBenchmarkOverride = (options = {}) => useMutation({
  mutationFn: (data) => benchmarksService.deleteBenchmarkOverride(data),
  ...options
});
